export enum ExceptionEnum {
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  JWT_NOT_VALID = 'JWT_NOT_VALID',
  JWT_BLACKLISTED = 'JWT_BLACKLISTED',
  CHAT_NOT_FOUND = 'CHAT_NOT_FOUND',
  SHARE_TOKEN_NOT_FOUND = 'SHARE_TOKEN_NOT_FOUND',
  SHARE_TOKEN_EXPIRED = 'SHARE_TOKEN_EXPIRED',
  PRESET_NOT_FOUND = 'PRESET_NOT_FOUND',
  TOOL_NOT_AVAILABLE = 'TOOL_NOT_AVAILABLE',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS',
  CONTENTFUL_PAT_NOT_SET = 'CONTENTFUL_PAT_NOT_SET',
  TOOL_PRESET_NOT_FOUND = 'TOOL_PRESET_NOT_FOUND',
  CONTENTFUL_TAG_NOT_FOUND = 'CONTENTFUL_TAG_NOT_FOUND',
  SKILL_NOT_FOUND = 'SKILL_NOT_FOUND',
  CONTENTFUL_TAG_ALREADY_EXISTS = 'CONTENTFUL_TAG_ALREADY_EXISTS',
  BYNDER_BRAND_ID_REQUIRED = 'BYNDER_BRAND_ID_REQUIRED',
  BYNDER_UPLOAD_FAILED = 'BYNDER_UPLOAD_FAILED',
  BYNDER_PROCESS_FAILED = 'BYNDER_PROCESS_FAILED',
  BYNDER_UPLOAD_POLLING_TIMED_OUT = 'BYNDER_UPLOAD_POLLING_TIMED_OUT',
  BYNDER_MEDIA_NOT_FOUND = 'BYNDER_MEDIA_NOT_FOUND',
  APACHE_TIKA_EXTRACT_FAILED = 'APACHE_TIKA_EXTRACT_FAILED',
  FILE_REQUIRED = 'FILE_REQUIRED',
  MESSAGE_NOT_FOUND = 'MESSAGE_NOT_FOUND',
  TOOL_APPROVAL_NOT_PENDING = 'TOOL_APPROVAL_NOT_PENDING',
  UNABLE_TO_DETERMINE_FILE_TYPE = 'UNABLE_TO_DETERMINE_FILE_TYPE',
  FILE_SIZE_EXCEEDED = 'FILE_SIZE_EXCEEDED',
  FILE_UPLOAD_FAILED = 'FILE_UPLOAD_FAILED',
  MCP_SERVER_NOT_FOUND = 'MCP_SERVER_NOT_FOUND',
}
